import { gql } from '@apollo/client';

const GET_HWT_CLASSROOM_SETTINGS = gql`
  query hwtClassroomSettings($where: PliClassroomSettingsWhereInput!) {
    hwtClassroomSettings(where: $where) {
      locale
    }
  }
`;

export default GET_HWT_CLASSROOM_SETTINGS;
